/* eslint-disable max-len */
var UI_CHEVRON_RIGHT = {
  "default": 'M25.47,16a1.25,1.25,0,0,1-.42.94L8.63,31.68A1.26,1.26,0,1,1,7,29.8L22.32,16,7,2.2H7A1.26,1.26,0,0,1,8.63.32L25.05,15.06A1.25,1.25,0,0,1,25.47,16Z',
  globetrotter: 'M9.25 2.5L22.75 16L9.25 29.5'
};

export { UI_CHEVRON_RIGHT };
//# sourceMappingURL=UI_CHEVRON_RIGHT.js.map
